import React from "react";
import styles from "./styles.css";
import Checkbox from "../../shared/checkbox";
import IconWhatsapp from "../icon-whatsapp";

const NotificationList = (props) => {
    return (
        <div styleName={"styles.notification"}>
            <Checkbox {...props} />
            Allow Notifications on
            <span styleName={"styles.whatsapp"}>
                <IconWhatsapp />
            </span>
            <b>WhatsApp</b>
        </div>
    );
};

export default NotificationList;
